import { Stack, Text } from '@mantine/core'
import { faCalendarDays } from '@fortawesome/sharp-duotone-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../Common/Button'
import { StatusMessage } from '../Common/StatusMessage'

export interface TaskEventReminderProps {
  // Opens Outlook's New Event form pre-filled from this task (MSD-684).
  onClick: () => void
  // Why the button is disabled (compose mode, mobile, unsupported host).
  disabledReason?: string | null
  loading?: boolean
  feedback?: { status: 'success' | 'error'; message: string } | null
}

export function TaskEventReminder({
  onClick,
  disabledReason = null,
  loading = false,
  feedback = null,
}: Readonly<TaskEventReminderProps>) {
  return (
    <Stack gap={4} mt="xs">
      <Button
        label="Add an Event Reminder"
        variant="filled"
        size="xs"
        w="fit-content"
        disabled={disabledReason != null}
        loading={loading}
        rightSection={<FontAwesomeIcon icon={faCalendarDays} size="xs" />}
        onClick={onClick}
      />
      {/* Shown rather than tooltipped: a disabled Mantine button swallows hover, so a
          tooltip would never fire on the one control that needs explaining. */}
      {disabledReason && (
        <Text fz="xs" c="dimmed">
          {disabledReason}
        </Text>
      )}
      {feedback && (
        <StatusMessage status={feedback.status} fz="xs">
          {feedback.message}
        </StatusMessage>
      )}
    </Stack>
  )
}
